var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 22,
    viewBox: "0 0 74 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9264_63656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8896 11.4054L49.1188 17.1136H24.8923L19.1104 11.4054H54.8896Z",
    fill: "#9E071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4559 5.70819L58.674 11.4054H15.326L9.55518 5.70819H64.4559Z",
    fill: "#C53437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 0L68.2292 5.70817H5.77085L0 0H74Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1765 22L15.1765 0H59.1765L37.1765 22Z",
    fill: "#00ACCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5955 2.07074H34.037V12.6982H31.5955V2.07074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7793 2.07074H38.2208V12.6982H35.7793V2.07074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9631 2.07074H42.4046V12.6982H39.9631V2.07074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9264_63656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/line_3.31601237fedd3ed65acec226ecc38532.svg";
export { ForwardRef as ReactComponent };